import styled from 'styled-components';

import { List } from '../List';

export const Wrapper = styled(List)``;
